import React from 'react';
import PropTypes from 'prop-types';

import { normalizeFormValue } from 'dpl/shared/form/utils';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import {
  OPTION_GROUP_VARIANTS,
  BOOLEAN_OPTIONS
} from 'dpl/quiz/option_group/utils/constants';
import OptionGroup from 'dpl/quiz/option_group/components/OptionGroup';
import OptionGroupOption from 'dpl/quiz/option_group/components/OptionGroupOption';

const INPUT_NAME = 'has_past_dogs';

export default function QuizPastDogsQuestion({
  formState,
  handleNextClick,
  onChange,
  isValid
}) {
  const hasPastDogs = normalizeFormValue(formState[INPUT_NAME]);

  return (
    <div className="AdoptionApplicationQuizPastDogsQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        icon="dogpark"
        isValid={isValid}
        title="Have you had dogs in the past?"
      >
        <OptionGroup
          variant={OPTION_GROUP_VARIANTS.CIRCLE}
          isListOnMobile={false}
        >
          {BOOLEAN_OPTIONS.map(o => (
            <OptionGroupOption
              type="radio"
              key={o.value}
              inputName={INPUT_NAME}
              value={o.value}
              title={o.title}
              isSelected={hasPastDogs === o.value}
              onSelect={onChange(handleNextClick)}
            />
          ))}
        </OptionGroup>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizPastDogsQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
